import React, {useCallback} from 'react';

import { openPricingModal } from '../../services/monday-service';
import { bigBrainTrack } from '../../services/bigbrain-service';
import { bigBrainEvents } from '../../constants';
import DocumentBrandComponent from './document-brand-component';
import './document-brand-component.scss';
import useCanFeatures from "../../hooks/use-can-features";
import { useMondayContext } from '../../contexts/monday-context';

export default function DocumentBrandWrapperComponent({ removeMondayBrand, updateUserSetting }) {
  const { canRemoveDocumentBranding } = useCanFeatures();
  const canChangeDocumentBrandSetting = canRemoveDocumentBranding;
  const {
    mondayContext: { boardId },
  } = useMondayContext();

  const changeSetting = useCallback(
    (checked) => {
      bigBrainTrack(bigBrainEvents.MONDAY_BRAND.MONDAY_BRAND_CHANGE, { info1: checked });
      updateUserSetting(checked);
    },
    [updateUserSetting]
  );

  const onCheckboxChange = useCallback(
    (e) => {
      changeSetting(e.target.checked);
    },
    [changeSetting]
  );

  const onLabelClick = useCallback(() => {
    changeSetting(!removeMondayBrand);
  }, [removeMondayBrand, changeSetting]);

  const onUpgradePlanClick = useCallback(() => {
    bigBrainTrack(bigBrainEvents.MONDAY_BRAND.UPGRADE_BUTTON_CLICK,{ info1: boardId });
    openPricingModal();
  }, [boardId]);

  return (
    <DocumentBrandComponent
      canChangeDocumentBrandSetting={canChangeDocumentBrandSetting}
      removeMondayBrand={removeMondayBrand}
      onCheckboxChange={onCheckboxChange}
      onLabelClick={onLabelClick}
      onUpgradePlanClick={onUpgradePlanClick}
    />
  );
}
